<!--下单-->
<template>
    <div style="height:100%;background:#f8f8f8;padding:0.2rem 0 1rem 0 ">
        <!-- 下单 -->

        <van-form
                @submit="onConfirm"
        >
            <van-cell-group>

                <van-field
                        v-model="formData.name"
                        readonly
                        label="姓名"
                        input-align="right"
                />

                <van-field
                        v-model="formData.num"
                        readonly
                        label="证件号"
                        input-align="right"
                />

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        @click="showGradePicker=true"
                        v-model="formData.grade"
                        error-message-align="right"
                        label="报考星级"
                        input-align="right"
                />


                <van-popup v-model="showGradePicker" position="bottom">
                    <van-picker :columns="gradeColumns"
                                show-toolbar
                                :default-index="formData.gradeindex-1"
                                @cancel="showGradePicker = false"
                                @confirm="onGradeConfirm"
                    />
                </van-popup>

                <van-cell title="添加证件照片(2寸)" >
                </van-cell>

                <div class="row">
                    <PicUploader :fileList="formData.pic" :limit="1"
                                 :name="'pic'"></PicUploader>
                </div>
                <div class="operate-desc-left">上传2寸免冠照,此照片用于证书粘贴打印</div>

                <!--<van-field-->
                        <!--v-model="formData.height"-->
                        <!--error-message-align="right"-->
                        <!--clearable-->
                        <!--:rules="[{ required: true, message: '请输入身高' }]"-->
                        <!--label="身  高"-->
                        <!--placeholder="请输入身高(cm)"-->
                        <!--input-align="right"-->
                <!--/>-->

                <!--<van-field-->
                        <!--v-model="formData.weight"-->
                        <!--error-message-align="right"-->
                        <!--clearable-->
                        <!--:rules="[{ required: true, message: '请输入体重' }]"-->
                        <!--label="体  重"-->
                        <!--placeholder="请输入体重(kg)"-->
                        <!--input-align="right"-->
                <!--/>-->


                <van-field
                        v-model="formData.csize"
                        error-message-align="right"
                        clearable
                        left-icon="question-o"
                        @click-left-icon="cSizeShow = true"
                        :rules="[{ required: true, message: '请输入尺码' }]"
                        label="衣服尺码"
                        placeholder="请输入尺码"
                        input-align="right"
                />
                <div @click="cSizeShow=true" class="operate-desc-left">查看衣服尺码表</div>

                <van-field
                        v-model="formData.footsize"
                        clearable
                        :rules="[{ required: true, message: '请输入鞋码' }]"
                        error-message-align="right"
                        label="鞋  码"
                        @click-left-icon="fSizeShow = true"
                        placeholder="请输入鞋码"
                        input-align="right"
                />
                <div @click="fSizeShow=true" class="operate-desc-left">查看鞋码表</div>

                <van-field
                        v-model="formData.famliy_name"
                        clearable
                        :rules="[{ required: true, message: '请输入家长姓名' }]"
                        error-message-align="right"
                        label="家长姓名"
                        placeholder="请输入家长姓名"
                        input-align="right"
                />

                <van-field
                        v-model="formData.famliy_num"
                        clearable
                        :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                        error-message-align="right"
                        label="身份证号码"
                        placeholder="请输入身份证号"
                        input-align="right"
                />


                <van-field
                        v-model="formData.phone"
                        clearable
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="联系方式"
                        placeholder="请输入手机号"
                        input-align="right"
                />



            </van-cell-group>
            <div style="height: 1rem"></div>

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."  >保存</van-button>
            </div>
        </van-form>


        <van-dialog v-model="cSizeShow" title="衣服尺码表"  >
            <img @click="picShow(key,cSizePicList)" v-for="(pic,key) in cSizePicList" :src="pic" style="width: 100%" />
        </van-dialog>
        <van-dialog v-model="fSizeShow" title="鞋码表"  >
            <p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>
            <img :src="fSizePicList[0]" @click="picShow(0,fSizePicList)"  style="width: 100%" />
        </van-dialog>


    </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

    .shop-name {
        display: flex;
        justify-content: space-between;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 27px;
        margin-top: 0.4rem;
        padding: 0 0.3rem;
    }
    .shop-address {
        height: 13px;
        font-size: 9px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 13px;
        margin-top: 0.1rem;
        padding: .2rem .3rem .4rem;
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
    .delivery-times {
        margin-top: 0.2rem;
        padding: 0 0.3rem;
        display: flex;
        justify-content: space-between;
    }
    .business-shop-info {
        width: 6.81rem;
        height: 2.66rem;
        border-radius: 7px;
        margin-bottom: 0;
        display: flex;
        flex-flow: column;
        position: absolute;
        bottom: -0.4rem;
        left: 0;
        right: 0;
        margin: auto;
        background: #fff
        6.5rem center;
        background-size: 10px;
    }
    .check-header {
        width: 100%;
        height: 4.4rem;
        background: url("https://static.dierqudao.com/images/dinghuoxitong/bg-mine-index.png")
        no-repeat center;
        background-size: 100%;
        position: relative;
    }

</style>

<script>
    import { Field, Notify, Toast, Popup, Picker,Radio,RadioGroup,Dialog,ImagePreview } from "vant";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    export default {
        name: "ExameApplyMemberAddMore",
        components: {
            [Field.name]: Field,
            Notify,
            Dialog,
            Radio,
            [ImagePreview.Component.name]: ImagePreview.Component,
            RadioGroup,
            Popup,
            PicUploader,
            Toast,
            Picker
        },
        data: function() {
            return {
                validator,
                isSubmit:false,
                confirmShow:false,
                id: this.$route.query.id,
                showNumTypePicker:false,
                cSizeShow:false,
                fSizeShow:false,
                showGradePicker:false,
                gradeColumns:['红','橙','黄','绿','青','蓝','紫'],
                cSizePicList:['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png','https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
                fSizePicList:['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
                message: "",
                formData: {
                    needLoadingIndicator: true,
                    gradeindex:0,
                    numTypeName:'身份证',
                    numtype:1,
                    id:this.$route.query.id,
                    name:'',
                    grade:'',
//                    num:'362323198807150036',
//                    pic:[{"uid":"vc-upload-1588058680174338","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-28/1588058680174338.png","name":" bg-doing.png","save_name":"h5/2020-04-28/1588058680174338.png"}],
                    pic:[],
//                    height:1,
//                    weight:2,
//                    footsize:3,
//                    famliy_name:'李',
//                    famliy_num:'320101197301011111',
//                    phone:'15177772222',
                },
                row:{
                },
                warnings: [],
                saveLoading:false,

            };
        },
        watch: {
        },

        filter: {},
        mounted() {
            document.title = "七彩星级连考";
            this.fetch();
        },
        destroyed() {},
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/qcxj/kaojiMemberAddDetail', {
                    id : that.id,
                }, (res) => {
                    that.formData = res.data;
                    that.formData.gradeindex = that.gradeColumns.indexOf(that.formData.grade)+1;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            onConfirm(values){
                console.log('onSubmit-values',values);
                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {
                    if(that.formData.pic.length==0){
                        Toast.fail('请上传证件照');
                        return
                    }
                }
                this.onConfirmSubmit();
            },
            onGradeConfirm(value, index){
                this.formData.grade = value;
                this.formData.gradeindex = index+1;
                this.showGradePicker = false;
            },
            onConfirmSubmit(){
                let that = this;
                that.saveLoading = true;
                that.$api.post('/api/qcxj/applyMemberAddMore', that.formData, (res) => {
                    that.saveLoading = false;
                    Toast.success('连考成功');
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            picShow(index,list){
                ImagePreview({
                    images: list,
                    startPosition: index,
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// ExameApplyMemberAddMore.vue?65453ece